import {
    GET_APPLAUNCH_CONFIG_SUCCESS,
    GET_APPLAUNCH_CONFIG_ERROR,
    APP_LAUNCH_REQUEST,
    APP_LAUNCH_SUCCESS,
    APP_LAUNCH_FAILURE,
    DISABLE_COVID_MSG,
    ENABLE_COVID_MSG
} from '../actions';

const initialState = {
    appLaunchConfig: null,
    loading:null,
    error:null,
    appLaunch:null,
    appLaunchExtra: null,
    showCovidMsg:null
};

export default function(state = initialState, action) {
    switch(action.type) {
        case APP_LAUNCH_REQUEST:
            return Object.assign({}, state, {
                loading: true,
                error: null
            });
            break;

        case APP_LAUNCH_SUCCESS: 
            return Object.assign({}, state, {
                appLaunch: action.appLaunch,
                appLaunchExtra: action.appLaunchExtra,
                loading: false,
                error: null, 
            });
            break;

        case APP_LAUNCH_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: action.error
            });
            break;

        case DISABLE_COVID_MSG:
            return Object.assign({}, state, {
                showCovidMsg: false 
            });
            break;
        case ENABLE_COVID_MSG:
            return Object.assign({}, state, {
                showCovidMsg: true 
            });
            break;

        case GET_APPLAUNCH_CONFIG_SUCCESS:
            return Object.assign({}, state, {appLaunchConfig: action.payload.data.data.appLaunch});
        default:
            return state;
    }
}
